import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "price-online-switch",
      class: { "price-online-switch--v5": _setup.ff_lpu_branding_page_v5 },
    },
    [
      _c(VSwitch, {
        staticClass: "ma-0 mt-0 pa-0",
        attrs: {
          "input-value": _vm.value,
          color: _setup.switchColor,
          inset: "",
          "hide-details": "",
          dense: "",
          "data-qa": "lpu_services_filter_online",
        },
        on: { change: _setup.onChange },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                _c(
                  "span",
                  { staticClass: "text-body-2 text--text text-no-wrap" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _setup.tStatic("Только услуги с онлайн-записью")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }